import { type ReactNode } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LoadingOverlay from 'components/common/LoadingOverlay';
import AuthLayout from 'components/layouts/AuthLayout';
import ScrollToTop from 'components/common/ScrollToTop';
import { DataProcessing, TermsOfUse } from 'pages/Legal';
import settings from 'config/settings';
import AppRouter from './AppRouter';
import AuthRouter from './AuthRouter';
import routePaths from './route-paths';
import useUser from '../hooks/user/useUser';

interface IRootRouterProps {
  children?: ReactNode;
}

const RootRouter = ({ children }: IRootRouterProps) => {
  const [user, loading] = useUser();
  let application = <AuthRouter />;

  if (loading && !user) application = <LoadingOverlay />;
  else if (user) application = <AppRouter />;

  return (
    <Router basename={settings.publicUrl}>
      {children}
      <Switch>
        <Route path={routePaths.termsOfUse} exact>
          <AuthLayout hideSignIn={loading || Boolean(user)}>
            <ScrollToTop />
            <TermsOfUse />
          </AuthLayout>
        </Route>
        <Route path={routePaths.dataProcessing} exact>
          <AuthLayout hideSignIn={loading || Boolean(user)}>
            <ScrollToTop />
            <DataProcessing />
          </AuthLayout>
        </Route>
        <Route>{application}</Route>
      </Switch>
    </Router>
  );
};

export default RootRouter;
